var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarnituraSticla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc132312-4838-48cb-8a97-9ec09a7b8fb1",
    "data-name": "garnitura_sticla",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2d4da52-12eb-4750-8c49-625befb22dff,.a7c8e600-e62e-4feb-bd6f-8c37d0f3de41,.b15b9b38-a408-4168-af3c-d9b428136908{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.a7c8e600-e62e-4feb-bd6f-8c37d0f3de41{stroke-width:10px;}.b15b9b38-a408-4168-af3c-d9b428136908{stroke-width:5px;}.a2d4da52-12eb-4750-8c49-625befb22dff{stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "garnitura_sticla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ba9302ce-b5b1-42ae-93a0-37a7598f7dc7",
    "data-name": "fereastra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "a7c8e600-e62e-4feb-bd6f-8c37d0f3de41",
    points: "28.75 188 195 188 195 5 5 5 5 139.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b15b9b38-a408-4168-af3c-d9b428136908",
    x1: 160.35,
    y1: 14.69,
    x2: 184.38,
    y2: 37.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "b15b9b38-a408-4168-af3c-d9b428136908",
    x1: 131.29,
    y1: 15.76,
    x2: 183.26,
    y2: 65.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a2d4da52-12eb-4750-8c49-625befb22dff",
    points: "20.77 129.79 20.77 172.85 54.29 172.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b15b9b38-a408-4168-af3c-d9b428136908",
    points: "31.94 129.26 31.94 162.09 53.73 162.09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarnituraSticla);
export default __webpack_public_path__ + "static/media/garnitura_sticla.58a4398969bce4328b240d8cce1eb00c.svg";
export { ForwardRef as ReactComponent };